import React, { Component } from "react";
import styles from "./reportTable.module.scss";
import { v4 as uuidv4 } from "uuid";

class ReportTableDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen:  true,
    };
  }

  getDashboard(dashboards) {
    return (
      <div key={uuidv4()} className={styles.reportTableDashboardContainer}>
        {dashboards
          .filter((x) => {
            return x !== null;
          })
          .map((dashboard) => {
            return this.getDashboardRow(dashboard);
          })}
      </div>
    );
  }

  getDashboardRow(dashboard) {
    return (
      <div className={styles.reportTableDashboardRow} key={uuidv4()}>
        {dashboard.map((item) => {
          if (item === null) {
            return <div key={uuidv4()} className={styles.reportTableDashboardItemEmpty}></div>;
          }

          return (
            <div key={uuidv4()} className={styles.reportTableDashboardItem}>
              <b>
                {item.title}
                {item.title !== "" ? ": " : ""}
              </b>
              <span>{item.value}</span>
              <span>{item.measure}</span>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { dashboards } = this.props;
    if (dashboards.length === 0) return null;

    const { isOpen } = this.state;

    if (!isOpen) {
      return null;
    }

    return this.getDashboard(dashboards);
  }
}

export default React.memo(ReportTableDashboard);
